// "+5 XP" flying text for the answer-correct moment. Step 6 doesn't have a
// real XP bar yet (Step 10), so the destination is whatever ref the page
// hands in — usually a placeholder badge in the header. The animation feel
// matters more than the data plumbing here.

import { motion } from 'framer-motion'
import type { PackId } from '@skena/schema'
import { PACK_PRIMARY_HEX } from './packPalette.ts'

interface XpFlyProps {
  /** Bumped on every fire to remount the motion node. */
  triggerKey: number
  amount: number
  packId: PackId
  from: { x: number; y: number }
  to: { x: number; y: number }
  onDone?: () => void
}

export function XpFly({ triggerKey, amount, packId, from, to, onDone }: XpFlyProps) {
  const color = PACK_PRIMARY_HEX[packId]
  return (
    <motion.div
      key={triggerKey}
      initial={{ opacity: 0, scale: 0.6, x: from.x, y: from.y }}
      animate={{
        opacity: [0, 1, 1, 0],
        scale: [0.6, 1.1, 1, 0.85],
        x: [from.x, from.x, to.x],
        y: [from.y, from.y - 36, to.y],
      }}
      transition={{ duration: 0.85, times: [0, 0.18, 0.85, 1], ease: 'easeOut' }}
      onAnimationComplete={() => onDone?.()}
      className="pointer-events-none fixed top-0 left-0 z-50 font-[family-name:var(--font-display)] text-2xl font-bold"
      style={{ color }}
      aria-hidden
    >
      +{amount} XP
    </motion.div>
  )
}
